import React, { useState } from 'react';
import axios from 'axios';

export default function NFTDisplay({ deviceId, nftIdentity, showMissingMessage }) {
  const [verificationResult, setVerificationResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const verifyNFT = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/devices/${deviceId}/nft/verify`);
      setVerificationResult(response.data.verificationResult);
    } catch (error) {
      setVerificationResult({ valid: false, reason: 'Verification failed' });
    } finally {
      setLoading(false);
    }
  };

  // Show missing message if requested or if nftIdentity is empty
  if (showMissingMessage || !nftIdentity || Object.keys(nftIdentity).length === 0) {
    return (
      <div className="card" style={{ marginTop: 10 }}>
        <h3>🔐 NFT Identity</h3>
        <p style={{ color: '#b94a48' }}>Loading NFT identity...</p>
        <button 
          className="btn" 
          onClick={() => window.location.reload()}
          style={{ marginTop: '10px' }}
        >
          Refresh NFT Data
        </button>
      </div>
    );
  }

  return (
    <div className="card" style={{ marginTop: 10 }}>
      <h3>🔐 NFT Digital Identity</h3>
      
      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        {/* NFT Token */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <h4>🪙 NFT Token</h4>
          <div style={{ 
            background: '#f8f9fa', 
            padding: '10px', 
            borderRadius: '4px',
            fontFamily: 'monospace',
            fontSize: '12px',
            wordBreak: 'break-all'
          }}>
            {nftIdentity.nftToken}
          </div>
        </div>

        {/* Device Fingerprint */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <h4>👆 Device Fingerprint</h4>
          <div style={{ 
            background: '#f8f9fa', 
            padding: '10px', 
            borderRadius: '4px',
            fontFamily: 'monospace',
            fontSize: '12px',
            wordBreak: 'break-all'
          }}>
            {nftIdentity.deviceFingerprint.substring(0, 32)}...
          </div>
        </div>
      </div>

      {/* Metadata */}
      <div style={{ marginTop: '20px' }}>
        <h4>📋 Device Metadata</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
          <div><strong>Type:</strong> {nftIdentity.metadata.deviceType}</div>
          <div><strong>Manufacturer:</strong> {nftIdentity.metadata.manufacturer}</div>
          <div><strong>Model:</strong> {nftIdentity.metadata.model}</div>
          <div><strong>Serial Number:</strong> {nftIdentity.metadata.serialNumber}</div>
          <div><strong>Hardware ID:</strong> {nftIdentity.metadata.hardwareId}</div>
          <div><strong>MAC Address:</strong> {nftIdentity.metadata.macAddress}</div>
          <div><strong>Created:</strong> {new Date(nftIdentity.metadata.createdAt).toLocaleString()}</div>
          <div><strong>Version:</strong> {nftIdentity.metadata.version}</div>
        </div>
      </div>

      {/* Digital Signature */}
      <div style={{ marginTop: '20px' }}>
        <h4>✍️ Digital Signature</h4>
        <div style={{ 
          background: '#f8f9fa', 
          padding: '10px', 
          borderRadius: '4px',
          fontFamily: 'monospace',
          fontSize: '12px',
          wordBreak: 'break-all'
        }}>
          {nftIdentity.digitalSignature.substring(0, 32)}...
        </div>
      </div>

      {/* Verification */}
      <div style={{ marginTop: '20px' }}>
        <h4>✅ Identity Verification</h4>
        <button 
          className="btn" 
          onClick={verifyNFT} 
          disabled={loading}
          style={{ marginBottom: '10px' }}
        >
          {loading ? 'Verifying...' : 'Verify NFT Identity'}
        </button>
        
        {verificationResult && (
          <div className={`alert ${verificationResult.valid ? 'alert-success' : 'alert-error'}`}>
            <strong>{verificationResult.valid ? '✅ Valid' : '❌ Invalid'}:</strong> {verificationResult.reason}
          </div>
        )}
      </div>

      {/* Blockchain Data */}
      <div style={{ marginTop: '20px' }}>
        <h4>⛓️ Blockchain Data</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
          <div><strong>Token ID:</strong> {nftIdentity.blockchainData.tokenId}</div>
          <div><strong>Block Number:</strong> {nftIdentity.blockchainData.blockNumber}</div>
          <div><strong>Transaction Hash:</strong> {nftIdentity.blockchainData.transactionHash}</div>
          <div><strong>Gas Used:</strong> {nftIdentity.blockchainData.gasUsed}</div>
        </div>
      </div>
    </div>
  );
} 